const locale = (lang) => (lang === 'en' ? 'en-US' : 'pl-PL');

export const currency = (lang) => (lang === 'en' ? 'PLN' : 'zł');

export const formatNumber = (value, lang, decimals = 0) =>
  value.toLocaleString(locale(lang), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true
  });

export const formatMoney = (value, lang, decimals = 0) => `${formatNumber(value, lang, decimals)} ${currency(lang)}`;

export const quote = (text, lang) => (lang === 'en' ? `“${text}”` : `„${text}”`);
